import CloseIcon from "@mui/icons-material/Close";
import { Button, ButtonGroup, TextField, Dialog } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import Currencies from "../../root/currency";
import CurrencyCashConfig from "../../root/CurrencyCashConfig";
import axios from "axios";
import configs from "../../Constants";
import { PropaneSharp } from "@mui/icons-material";

const CashPaymentDialog = ({
  handlePayMode,
  setCashPayDialog,
  totalAmount,
  order,
  cashout
}) => {
  const [cashAmount, setCashAmount] = useState(0);
  const [otherAmount, setOtherAmount] = useState(0);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [changeDue, setChangeDue] = useState(totalAmount);
  const { formatMessage: t, locale } = useIntl();
  const [payConfirmDialog, setPayConfirmDialog] = useState(false);
  let merchantData = localStorage.getItem("merchantData")
    ? JSON.parse(localStorage.getItem("merchantData"))
    : null;
  const formatter = new Intl.NumberFormat(localStorage.getItem("locale") || 'en-US', {
    style: 'currency',
    currency: merchantData?.currency || 'USD'
  });
  let userData = window.localStorage.getItem("userData")
    ? JSON.parse(window.localStorage.getItem("userData"))
    : "";
  const handleOtherPaymentSelection = (index) => {
    setSelectedMethod(index);
    // Auto-fill the split amount with the remaining due amount
    const due = parseFloat(changeDue);
    const autofill = due > 0 ? parseFloat(due.toFixed(2)) : 0;
    setOtherAmount(autofill);
    calculateChangeDue(cashAmount, autofill);
  };
  const fetchCustomerCredit = async (customerId) => {
    try {

      const res = await axios.get(`${configs.baseURL}/api/cust_credits`, {
        params: {
          customerId: customerId,
          merchantId: merchantData.merchantCode
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });

      const credits = res.data;

      if (credits.length) {
        return credits[credits.length - 1].balanceAfter;
      }

      return 0;

    } catch (err) {
      console.log("Credit fetch error:", err);
      return 0;
    }
  };

  const saveSplitCreditPurchase = async () => {

    try {

      const customerId = order.customerId;

      const creditAmount = parseFloat(otherAmount || 0);

      const oldBalance = await fetchCustomerCredit(customerId);

      const newBalance = oldBalance + creditAmount;

      await axios.post(
        `${configs.baseURL}/api/cust_credits`,
        {
          transactionId: Date.now().toString(),
          customerId: customerId,
          merchantId: merchantData.merchantCode,
          type: "purchase",
          amount: creditAmount,
          balanceAfter: newBalance,
          paymentMethod: "Credit"
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        }
      );

    } catch (err) {
      console.log("Split credit save error:", err);
    }

  };
  const handleCashAmountChange = (e) => {
    const newCashAmount = e.target.value;
    setCashAmount(newCashAmount);
    calculateChangeDue(newCashAmount, otherAmount);
  };

  const handleOtherAmountChange = (e) => {
    const newOtherAmount = e.target.value;
    setOtherAmount(newOtherAmount);
    calculateChangeDue(cashAmount, newOtherAmount);
  };



  const calculateChangeDue = (cashAmount, otherAmount) => {
    const paidAmount =
      (parseFloat(cashAmount) || 0) + (parseFloat(otherAmount) || 0);
    const change = totalAmount - paidAmount;
    setChangeDue(Math.round(change.toFixed(2) * 10) / 10);

  };
  // const merchantData = JSON.parse(localStorage.getItem("merchantData"));
  // const currencyCode = merchantData?.currency || "USD";
  // const currencyObj = Currencies.find(c => c.abbreviation === currencyCode);
  // const currencySymbol = currencyObj?.symbol || currencyCode;

  const handleNextClick = async () => {

    let secondMode = "";

    if (selectedMethod == 1) secondMode = "upi";
    else if (selectedMethod == 2) secondMode = "card";
    else if (selectedMethod == 3) secondMode = "coupon";
    else if (selectedMethod == 4) secondMode = "credit";

    // ? CREDIT split payment
    if (secondMode === "credit") {
      await saveSplitCreditPurchase();
    }

    console.log("====change amount ==", changeDue);

    handlePayMode("CASH", "", "", secondMode, otherAmount, changeDue);

    setCashPayDialog(false);

  };
  // const denominations = [1, 2, 5, 10, 20, 50, 100, 200, 500];
  const encodeQueryData = (data) => {
    const ret = [];
    for (let d in data)
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    return ret.join('&');
  }
  const purchase_tx = () => {

    const merchantId = userData.merchantCode;
    //const amount = parseFloat(order.totalPrice);



    if (userData?.paymentProviderType?.toLowerCase() == 'fygaro' || merchantData?.paymentProviderType?.toLowerCase() == 'fygaro') {

      setPayConfirmDialog(`https://www.fygaro.com/en/pb/${userData?.paymentProviderCode}/+?amount=${order.totalPrice}&client_note=digifyPoS&client_reference=${order?.invoicePath || new Date().getTime()}&return_url=https://www.fygaro.com/`);
    } else if (userData?.paymentProviderType?.toLowerCase() == 'verifone' || merchantData?.paymentProviderType?.toLowerCase() == 'verifone') {
      let data = {
        amount: parseFloat(otherAmount || 0) + parseFloat(cashout || 0),
        cash_amount: parseFloat(cashout || 0),
        reference_id: Math.random().toString(36).substring(2, 10),
        register_id: merchantData?.firstName + (userData?.firstName || userData?.name),
        merchant_id: merchantId
      };
      console.log(data);
      let queryStr = encodeQueryData(data);
      setPayConfirmDialog('https://vcloud.alt-payment.com/webint/purchase/NextOrder?' + queryStr);
      // $('#myModal').modal('show');
    }
  }

  const orderCurrency = order?.currency;
  const currencyCode =
    (orderCurrency && orderCurrency.toUpperCase()) ||
    (merchantData?.currency && merchantData.currency.toUpperCase()) ||
    "USD";


  const getCurrencySymbol = () => {
    const cur = Currencies.filter(
      (curen) => curen.abbreviation === currencyCode
    );
    return cur.length ? cur[0].symbol : currencyCode;
  };

  const currencySymbol = getCurrencySymbol();


  const rawDenominations = [
    ...(CurrencyCashConfig[currencyCode]?.coins || []),
    ...(CurrencyCashConfig[currencyCode]?.notes || [])
  ];

  const extractNumber = (label) => {
    const match = label.match(/[\d.]+/);
    return match ? Number(match[0]) : 0;
  };
  const handleAddCash = (value, isReplace) => {
    const newCash = isReplace ? value : parseFloat(cashAmount || 0) + value;
    setCashAmount(newCash);
    calculateChangeDue(newCash, otherAmount);
  };

  const event_handler2 = (event) => {
    try {
      console.info('EVENT: Received event cashpaymet -----');

      var data;
      data = event.data;
      console.log(data);

      if (data && typeof data == 'string' && (JSON.parse(data)?.result == "FAILURE" || JSON.parse(data)?.result == "CANCELLED" || JSON.parse(data)?.result == "NOCONNECTION" || JSON.parse(data)?.result == "SUCCESS")) {
        setPayConfirmDialog(false);

      }
    }
    catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    //if (userData?.paymentProviderType?.toLowerCase() == 'verifone') {
    window.addEventListener('message', (event) => event_handler2(event), false);
    //}
  }, []);

  return (
    <div id="cash-dialog">
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <b>{t({ id: "cash_change" })}</b>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => setCashPayDialog(false)}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        style={{
          borderTop: "1px solid #ccc",
          borderBottom: "1px solid #ccc",
          padding: "0px 5px",
        }}
      >
        {/* Two-column layout: left = bill info + inputs, right = numpad */}
        <div style={{ display: "flex", flexDirection: "row", gap: "2px", alignItems: "flex-start", marginTop: "10px" }}>

          {/* LEFT COLUMN */}
          <div style={{ display: "flex", flexDirection: "column", flex: 1, gap: "5px" }}>

            {/* Bill Amount */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "5px", marginBottom: "15px" }}>
              <label style={{ fontSize: "1.1rem", color: "#345d75" }}>{t({ id: "bill_amount" })}:</label>
              <h2 style={{ margin: 0 }}>
                <b>{formatter.format(totalAmount).replace('JMD', 'J$').replace(/\s+/, "")}</b>
              </h2>
            </div>

            {/* Paid by Cash */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "5px", marginBottom: "15px" }}>
              <label style={{ fontSize: "1.1rem", color: "#345d75" }}>{t({ id: "paid_by_cash" })}:</label>
              <TextField
                variant="outlined"
                type="number"
                size="small"
                value={cashAmount}
                onChange={(e) => (setCashAmount(e.target.value), handleAddCash(e.target.value, true))}
                style={{ width: "150px" }}
                inputProps={{ style: { fontSize: "1.4rem" } }}
              />
            </div>

            {/* Split Pay */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "5px", marginTop: "10px", marginBottom: "15px" }}>
              <label style={{ fontSize: "1.1rem", color: "#345d75" }}>{t({ id: "split_pay_by" })}:</label>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px", flexWrap: "wrap", width: "100%" }}>
                <ButtonGroup style={{ textAlign: "left" }}>
                  {[
                    { id: 1, label: "QR/SCAN", value: "1" },
                    { id: 2, label: "CARD", value: "2" },
                    { id: 3, label: "COUPON", value: "3" },
                    { id: 4, label: "CREDIT", value: "4" }
                  ]
                    .filter(method => (merchantData?.paymentMethods ? merchantData.paymentMethods.split(",") : ["0", "1", "2"]).includes(method.value))
                    .map((method) => (
                      <Button
                        key={method.id}
                        variant={selectedMethod === method.id ? "contained" : "outlined"}
                        onClick={() => handleOtherPaymentSelection(method.id)}
                      >
                        {method.label}
                      </Button>
                    ))}
                </ButtonGroup>
                {selectedMethod && (
                  <TextField
                    variant="outlined"
                    type="number"
                    size="small"
                    value={otherAmount}
                    onChange={handleOtherAmountChange}
                    style={{ width: "120px", minWidth: "100px" }}
                  />
                )}
                {selectedMethod && <img
                  height="auto"
                  width="70px"
                  alt=""
                  style={{ height: "auto", cursor: "pointer" }}
                  src={"/swiping.svg"}
                  onClick={() => purchase_tx()}
                />}
              </div>
            </div>

            {/* Change Due */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "5px", marginBottom: "15px" }}>
              <label style={{ fontSize: "1.1rem", color: "#345d75" }}>{t({ id: "change_due" })} <span style={{ fontSize: '12px', fontWeight: "normal", color: "#666" }}>{'(Note: -(Minus) Means, return amount)'}</span>:</label>
              <h2 style={{ color: changeDue > 0 ? "red" : "green", margin: 0 }}>
                <b>{formatter.format(changeDue).replace('JMD', 'J$').replace(/\s+/, "")}</b>
              </h2>
            </div>

          </div>

          {/* RIGHT COLUMN — Numpad aligned to top */}
          <div style={{ alignSelf: "flex-start", marginTop: "0px" }}>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "12px" }}>
              {["1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "0", "⌫"].map((key) => (
                <Button
                  key={key}
                  variant="contained"
                  style={key === "⌫"
                    ? { backgroundColor: "#d32f2f", color: "#fff", fontSize: "1.4rem", padding: "15px 20px", minWidth: "64px" }
                    : { backgroundColor: "#000", color: "#fff", fontSize: "1.4rem", fontWeight: "bold", padding: "15px 20px", minWidth: "64px" }}
                  onClick={() => {
                    let currentAmountStr = cashAmount ? cashAmount.toString() : "";
                    if (currentAmountStr === "0" && key !== ".") currentAmountStr = "";

                    let newAmountStr;
                    if (key === "⌫") {
                      newAmountStr = currentAmountStr.slice(0, -1);
                      if (newAmountStr === "") newAmountStr = "0";
                    } else {
                      if (key === "." && currentAmountStr.includes(".")) return;
                      newAmountStr = currentAmountStr + key;
                    }
                    setCashAmount(newAmountStr);
                    calculateChangeDue(newAmountStr, otherAmount);
                  }}
                >
                  {key}
                </Button>
              ))}
            </div>
          </div>

        </div>
      </DialogContent >
      <DialogActions>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "10px",
            width: "100%",
          }}
        >
          <Button
            variant="outlined"
            color="error"
            onClick={() => setCashPayDialog(false)}
          >
            {t({ id: "cancel" })}
          </Button>
          <Button
            variant="contained"
            onClick={handleNextClick}
            disabled={parseFloat(changeDue) > 0 || parseFloat(cashAmount) < 0.01}
          >
            {t({ id: "Next" })}
          </Button>
        </div>
      </DialogActions>
      <Dialog
        open={payConfirmDialog}
        style={{ zIndex: 9999999 }}
      >
        <div class="modal-body" style={{ height: "600px" }}>
          <iframe id="txFrame" src={payConfirmDialog} frameborder="0" allowtransparency="true" style={{ width: "100%", height: "100%" }}></iframe>
        </div>
      </Dialog>
    </div >

  );
};

export default CashPaymentDialog;
